module.exports = __webpack_public_path__ + "img/audi-event3.7a3b92c1.jpg";